import { render } from "./change-password.vue?vue&type=template&id=91f663ca"
import script from "./change-password.vue?vue&type=script&lang=js"
export * from "./change-password.vue?vue&type=script&lang=js"
script.render = render

export default script